// extracted by mini-css-extract-plugin
export default {"title":"Z_-z","warning":"__-z","sizeOptionsLegendText":"aaa-z"};